import { Stack, Text } from "flicket-ui";
import pluralize from "pluralize";
import { Badge } from "~components";
import PriceWithFee from "~components/reservation/common/common.PriceWithFee";
import { HighDemandModalContentAffectedTicket } from "./HighDemandModalContent";

interface HighDemandModalTicketCardProps {
  ticket: HighDemandModalContentAffectedTicket;
  showFees: boolean;
  currency: string;
}
export function HighDemandModalTicketCard({
  ticket,
  showFees,
  currency,
}: HighDemandModalTicketCardProps) {
  return (
    <Stack
      direction="vertical"
      gap="1/2"
      backgroundColor="white"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="N200"
      borderRadius="md"
      padding={2}
    >
      <Stack direction="horizontal" gap={1} justifyContent="space-between">
        <Stack direction="vertical" gap="1/2">
          <Text variant="header.S">{ticket.name}</Text>
          <Text variant="regular">
            <PriceWithFee
              price={ticket.price}
              fee={ticket.fee}
              currency={currency}
              showFees={showFees}
            />
          </Text>
          {ticket.customBadge && (
            <Badge
              color={ticket.customBadge.backgroundColor}
              textColor={ticket.customBadge.textColor}
              alignSelf="flex-start"
            >
              {ticket.customBadge.label}
            </Badge>
          )}
        </Stack>
        <Text variant="header.XS">
          x {pluralize("ticket", ticket.quantity, true)}
        </Text>
      </Stack>
    </Stack>
  );
}
